module.exports = __webpack_public_path__ + "img/Game2MP.0a3cd50d.png";